import React, { Suspense } from "react";

const CreditConfiguration = React.lazy(() => import("@/pages/credit-configuration"));

export default function CreditConfigurationContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <CreditConfiguration />
    </Suspense>
  );
}
